import {
  IntegrationChannelType,
  IntegrationDirection,
} from 'generated/graphql';

export const isOutboundIntegrationForChannelType = (
  channelType: IntegrationChannelType,
  direction: IntegrationDirection,
  outboundChannelType: IntegrationChannelType,
) => {
  return (
    channelType === outboundChannelType &&
    direction === IntegrationDirection.Outbound
  );
};
